import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './RecordingsContainer.css';
import windowSize from 'react-window-size';
import RobotMessageComponent from '../../Components/RobotMessageComponent/RobotMessageComponent';
import RecordingsTable from './Table/RecordingsTable';
import RecordingsChartContainer from './Chart/RecordingsChartContainer';
import RecordingsStats from './Stats/RecordingsStats';
import RecordingsRangeFilter from './Filters/RecordingsRangeFilter';
import RecordingsDateRangeSelector from './Filters/RecordingsDateRangeSelector';
import { actions } from '../../Reducks/Recordings';
import SelectedRecord from '../../Components/SelectedRecord/SelectedRecord';
import moment from 'moment-timezone';
import { RobotMessageState, RecordingSource } from '../../Utils/Constants';
import Tips from '../../Components/Tips/Tips';
import { desktopSkeletonScreen, mobileSkeletonScreen } from '../../SkeletonScreens/SkeletonScreen';
import { RECORDINGS_OVERVIEW } from '../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import AppConstants from '../../AppConstants';
import { getRecordings } from '../../Reducks/Recordings/RecordingsActions';

export class RecordingsContainer extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    tips: PropTypes.array,
    isBig: PropTypes.bool,
    filterRecordings: PropTypes.func,
    reduced_recordings: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      focusedRecordingKeyInTable: null,
      focusedRecordingKeyInChart: null
    };
    this.mixpanelData = {
      action: RECORDINGS_OVERVIEW
    };
  }

  render() {
    const { recordings, fetching, error } = this.props.reduced_recordings;
    const isEmptyOrError = (recordings.allKeys && recordings.allKeys.length === 0 && !fetching) || error;
    const { isBig } = this.props;
    if (fetching) {
      if (isBig) {
        return <div className="recordingsContainer">{desktopSkeletonScreen()}</div>;
      } else {
        return <div className="recordingsContainer">{mobileSkeletonScreen()}</div>;
      }
    }

    return (
      <div className="recordingsContainer">
        {isBig && this.dateAndFilterRow()}
        {!isBig && this.selectedRecordRow()}
        {this.statsCardsRow()}
        {isBig && AppConstants.TIPS_ENABLED && this.tipsRow()}
        {isEmptyOrError ? (
          <RobotMessageComponent type={error ? RobotMessageState.ERROR_STATE : RobotMessageState.EMPTY_STATE} />
        ) : (
          <div className="chartAndTable">
            {this.chartRow()}
            {this.tableRow()}
          </div>
        )}
      </div>
    );
  }

  dateAndFilterRow = () => {
    const { t } = this.context;
    const { reduced_recordings, getRecordings } = this.props;
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div className="overviewHeading">{t('header.overview')}</div>
        <div className="d-flex justify-content-between align-items-center spreadHorizontalItems-8">
          <RecordingsRangeFilter
            isBig={true}
            uniqueId={'recordingsFilterInRecordingsContainer'}
            mixpanelData={this.mixpanelData}
          />
          <RecordingsDateRangeSelector
            isBig={true}
            uniqueId={'recordingsDateRangeSelectorInContainer'}
            mixpanelData={this.mixpanelData}
            getRecordings={getRecordings}
            reduced_recordings={reduced_recordings}
          />
        </div>
      </div>
    );
  };

  selectedRecordRow = () => {
    const { t } = this.context;
    return (
      <SelectedRecord
        defaultTitle={t('header.overview')}
        defaultSubTitle={this.getSelectedDateRangeString()}
        title={this.getSelectedRecordingName()}
        subTitle={this.getSelectedRecordingPublishedTime()}
      />
    );
  };

  statsCardsRow = () => {
    const { recordings, stats } = this.props.reduced_recordings;
    const totalRecordings = recordings.filteredKeys.length;
    const selectedRecordingsCount = recordings.filteredSelectedRecordingKeys.length;
    const { isBig } = this.props;

    return (
      <RecordingsStats
        isBig={isBig}
        totalRecordings={totalRecordings}
        totalStandaloneViews={stats.filteredSelectedStandaloneTotalViews}
        totalG2SViews={stats.filteredSelectedG2STotalViews}
        totalG2SShares={stats.filteredSelectedG2STotalShares}
        selectedRecordingsCount={selectedRecordingsCount}
        selectedRecording={recordings.byKey[this.state.focusedRecordingKeyInTable]}
      />
    );
  };
  tipsRow = () => <Tips contents={this.props.tips} mixpanelData={this.mixpanelData} />;

  chartRow = () => {
    const { isBig } = this.props;
    return (
      <RecordingsChartContainer
        focusRecordingInTable={this.focusRecordingInTable}
        focusedRecordingKeyInChart={this.state.focusedRecordingKeyInChart}
        isBig={isBig}
      />
    );
  };
  tableRow = () => {
    const { isBig, reduced_recordings } = this.props;
    return (
      <RecordingsTable
        uniqueId={'recordingTableInOverview'}
        isBig={isBig}
        recordingsData={reduced_recordings.recordings}
        focusedRecordingKeyInTable={this.state.focusedRecordingKeyInTable}
        focusRecordingInChart={this.focusRecordingInChart}
        reportSource={[RecordingSource.G2W, RecordingSource.G2S, RecordingSource.G2S_EMBEDDED]}
        mixpanelData={this.mixpanelData}
      />
    );
  };

  focusRecordingInTable = recordingKey => {
    this.setState({ focusedRecordingKeyInTable: recordingKey });
  };

  focusRecordingInChart = recordingKey => {
    this.setState({ focusedRecordingKeyInChart: recordingKey });
  };

  getSelectedRecordingName = () => {
    const { recordings } = this.props.reduced_recordings;
    const { focusedRecordingKeyInTable } = this.state;
    return focusedRecordingKeyInTable ? recordings.byKey[focusedRecordingKeyInTable].title : null;
  };

  getSelectedRecordingPublishedTime = () => {
    const { t } = this.context;
    const { recordings } = this.props.reduced_recordings;
    const { focusedRecordingKeyInTable } = this.state;
    const { dateUploaded } = focusedRecordingKeyInTable ? recordings.byKey[focusedRecordingKeyInTable] : {};
    if (dateUploaded) {
      return moment(dateUploaded).format(t('formatting.dayDate'));
    }
    return null;
  };

  getSelectedDateRangeString = () => {
    const { t } = this.context;
    const { fromTime, toTime } = this.props.reduced_recordings.filter;
    if (fromTime && toTime) {
      return `${moment(fromTime).format(t('formatting.date'))} - ${moment(toTime).format(t('formatting.date'))}`;
    }
    return null;
  };
}

export default windowSize(
  connect(
    state => ({
      reduced_recordings: state.reduced_recordings
    }),
    {
      filterRecordings: actions.filterRecordingsByCount,
      getRecordings: getRecordings
    }
  )(RecordingsContainer)
);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/RecordingsContainer.js